/**
 * resource component to collect and organize agenda items by that
 * are part of studies that have been grouped by sponsor 
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import AgendaTmListItem from './AgendaTmListItem.js.jsx';
// not updating links here because this should no longer be used with london handling agenda

class GroupWithSponsorAgendaItems extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    const { 
      agendaItems
      , showAll 
      , showOptional
      , sponsor 
      , contentModuleStore 
    } = this.props;

    const optional = _.groupBy(agendaItems, 'optional');

    const requiredExpired = optional && optional.false ? optional.false.filter(item => item.certificateStatus === 'expired') : [];
    const requiredExpiringSoon = optional && optional.false ? optional.false.filter(item => item.certificateStatus === 'expiring-soon') : [];
    const requiredPending = optional && optional.false ? optional.false.filter(item => item.certificateStatus === 'pending-attestation') : [];
    const requiredIncomplete = optional && optional.false ? optional.false.filter(item => !item.valid && item.certificateStatus !== 'expiring-soon' && item.certificateStatus !== 'expired' && item.certificateStatus !== 'pending-attestation') : [];
    const requiredComplete = optional && optional.false ? optional.false.filter(item => item.valid && item.certificateStatus !== 'expiring-soon') : [];

    const optionalExpired = optional && optional.true ? optional.true.filter(item => item.certificateStatus === 'expired') : [];
    const optionalExpiringSoon = optional && optional.true ? optional.true.filter(item => item.certificateStatus === 'expiring-soon') : [];
    const optionalPending = optional && optional.true ? optional.true.filter(item => item.certificateStatus === 'pending-attestation') : [];
    const optionalIncomplete = optional && optional.true ? optional.true.filter(item => !item.valid) : [];
    const optionalComplete = optional && optional.true ? optional.true.filter(item => item.valid && item.certificateStatus !== 'expiring-soon') : [];

    return (
      <div>
        { showAll ?
          <div className="agenda-header">
            <img className="-logo" src={sponsor.logo}/>
            <div>
              <h1 className="-study-name">Sponsor Agenda for {sponsor.name}</h1>
              <p><em>Viewing all grouped programming for this sponsor</em></p>
            </div>
          </div>
          :
          <div>
            <div className="-sponsor-top">
              <Link to={`/my-agenda/sponsor/${sponsor._id}`}>
                <p className="group-title">Grouped Programming</p>
              </Link>
              <p className="-info">
                { // Check how many of the user's completed modules live within this course 
                  requiredComplete.length + requiredExpiringSoon.length
                }
                <span> of </span>
                { 
                  optional && optional.false ? optional.false.length : 0
                } 
                <span> required modules completed</span>
              </p>  
            </div>
          </div>
        }
        
        <div>
          { !showAll && requiredExpired.length === 0 && requiredExpiringSoon.length === 0 && requiredPending.length === 0 && requiredIncomplete.length === 0 ?
            <div className="-all-caught-up">
              <div className="u-centerText">
                <div className="-icon">
                  <i className="far fa-check-circle fa-3x"/>
                </div>
                <div className="-message">You have completed all required training for this program!</div>
                <br/>
                <Link className="yt-btn primary" to={`/my-agenda/sponsor/${sponsor._id}`}>View all completed & optional training &rarr;</Link>
              </div>
            </div>
            :
            <div className="-agenda-tm-list">
              {/* <p>Expired</p> */}
              { requiredExpired.map((agendaItem, i) => 
                <AgendaTmListItem
                  agendaItem={agendaItem}
                  key={'reqExp_' + agendaItem._contentModule + '_' +i }
                  contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                /> 
              )}
              {/* <p>Expiring soon</p>  */}
              { requiredExpiringSoon.map((agendaItem, i) => 
                <AgendaTmListItem
                  agendaItem={agendaItem}
                  key={'reqExpSoon_' + agendaItem._contentModule + '_' +i }
                  contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                /> 
              )}
              {/* <p>Pending attestation</p> */}
              { requiredPending.map((agendaItem, i) => 
                <AgendaTmListItem
                  agendaItem={agendaItem}
                  key={'reqPending_' + agendaItem._contentModule + '_' +i }
                  contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                /> 
              )}
              {/* <p>Incomplete</p> */}
              { showAll ?
                  <div>
                    {requiredIncomplete.map((agendaItem, i) => 
                      <AgendaTmListItem
                        agendaItem={agendaItem}
                        sponsor={sponsor}
                        key={'reqInc_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                    { requiredComplete.map((agendaItem, i) => 
                      <AgendaTmListItem
                        agendaItem={agendaItem}
                        sponsor={sponsor}
                        key={'reqComp_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                  </div>
                  : 
                  <div>
                    {requiredIncomplete.slice(0,5).map((agendaItem, i) => 
                      <AgendaTmListItem
                        agendaItem={agendaItem}
                        sponsor={sponsor}
                        key={'reqInc_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                  </div>
                }
              <div className="yt-row space-between">
                { !showAll && requiredIncomplete.length > 5 ?
                  <small>Showing {5 + requiredExpired.length + requiredExpiringSoon.length + requiredPending.length } of {optional && optional.false && optional.false.length } modules</small>
                  :
                  <small>Showing all grouped & required training</small>
                }
                { !showAll && 
                  <small>
                    <Link to={`/my-agenda/sponsor/${sponsor._id}`}>View all training for this sponsor</Link>
                  </small>
                }
              </div>
            </div>
          }
          { showOptional ? 
            <div className="-study-wrapper">
              <div className="-sponsor-top">
                <p className="-study-name">Additional Training</p>
                <p className="-info">
                  { // Check how many of the user's completed modules live within this course 
                    optionalComplete.length 
                  }
                  <span> of </span>
                  { 
                    optional && optional.true ? optional.true.length : 0
                  } 
                  <span> optional modules completed</span>
                </p>  
              </div>
              
              <div className="-agenda-tm-list">
                { optionalExpired.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'optExp_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                {/* <p>Expiring soon</p>  */}
                { optionalExpiringSoon.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'optExpSoon_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                {/* <p>Pending attestation</p> */}
                { optionalPending.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'optPending_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                { optionalIncomplete.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'optInc_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                { showAll ? optionalComplete.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'optComp_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                  )
                  : null 
                }
              </div>
            </div>
            :
            null 
          }
        </div>
      </div>
    )
  }
}

GroupWithSponsorAgendaItems.propTypes = {
  agendaItems: PropTypes.array.isRequired
  , dispatch: PropTypes.func.isRequired
  , showAll: PropTypes.bool 
  , showOptional: PropTypes.bool 
  , sponsor: PropTypes.object.isRequired 
}

GroupWithSponsorAgendaItems.defaultProps = {
  showAll: false 
  , showOptional: false 
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , moduleCertificateStore: store.moduleCertificate
    , sponsorStore: store.sponsor
    , courseStore: store.course
    , contentModuleStore: store.contentModule
    , userModuleStore: store.userModule 
  }
}

export default connect(mapStoreToProps)(GroupWithSponsorAgendaItems);



// WEBPACK FOOTER //
// modules/agenda/components/GroupWithSponsorAgendaItems.js.jsx